import { useSelector } from 'react-redux'

import { FormattedMessage } from 'react-intl'

import { selectTerritories } from '@/features/domain/territory'

import { useRequestChangePlanModal } from '../../../modals/RequestChangePlanModal'

import { Alert, Button, Paper, Stack, Tooltip, Typography } from '@mui/material'
import { Tag } from '@workwave-tidal/core/components'

import { useTexts } from '../useTexts'

import { PaperStyle, PrimaryTagStyle } from '../../commonStyles'

const countriesAllowedToRequestSms = [
  'US',
  'CA',
  'IT',
  'GB',
  'AU',
  'ES',
  'PT',
  'IE',
  'SE',
  'SA',
  'DK',
  'BE',
]

export function CurrentPlan() {
  const texts = useTexts()

  const territories = useSelector(selectTerritories)

  const { show: showRequestChangePlan, Modal: RequestChangePlanModal } = useRequestChangePlanModal()

  const countries = [...new Set(Object.values(territories).map(t => t.country))]
  const canChangePlan = countries.some(country => countriesAllowedToRequestSms.includes(country))

  const buttonDisabled = !canChangePlan

  return (
    <>
      <Paper elevation={0} sx={PaperStyle}>
        <Stack direction="column" spacing={2}>
          <Stack direction="column" spacing={1}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography variant="subtitle3">{texts.currentPlanLabel}</Typography>
              <Tag sx={PrimaryTagStyle} label={texts.planName} variant="outlined" color="primary" />
            </Stack>

            <Typography variant="caption" color="text.secondary">
              {texts.currentPlanDescription}
            </Typography>
          </Stack>

          <Alert severity="info" variant="outlined">
            <Typography variant="body2">
              <FormattedMessage
                id="info-description"
                defaultMessage={texts.warningDescription}
                values={{
                  b: chunks => (
                    <Typography fontWeight={600} display="inline">
                      {chunks}
                    </Typography>
                  ),
                }}
              />
            </Typography>
          </Alert>

          <Tooltip
            title={buttonDisabled ? texts.changePlanDisabled : texts.changePlan}
            placement="top"
          >
            <span>
              <Button
                variant="outlined"
                onClick={showRequestChangePlan}
                data-testid="settings-communication-edit-plan-button"
                data-trackid="settings-communication-edit-plan-button"
                disabled={buttonDisabled}
                fullWidth
              >
                {texts.changePlan}
              </Button>
            </span>
          </Tooltip>
        </Stack>
      </Paper>

      <RequestChangePlanModal />
    </>
  )
}
